import React, { useEffect } from "react";
import { getCompany, updateAmountOfAccounts, updateCompanyReference } from "../../services/AdminService";
import { Alert, Button, Card, Col, Container, Form, Row } from "react-bootstrap";
import { getCompanyServices, getCompanyUsers } from "../../services/companyservice";
import { AddServicesModal } from "../Components/AddServicesModal";
import { formatAllowWebText, formatText } from "../../components/CONSTANTS";
import { getAllCompanyLeads } from "../../services/Leadservice";

export const AdminCompanyDetailsDashboard = ({ match }) => {

    const [company, setCompany] = React.useState({});
    const [error, setError] = React.useState(false);
    const [errorText, setErrorText] = React.useState("");
    const [loading, setLoading] = React.useState(false);
    const [amountRef, setAmountRef] = React.useState();
    const [referenceAdmin, setReferenceAdmin] = React.useState();
    const [services, setServices] = React.useState([]);
    const [companyUsers, setCompanyUsers] = React.useState([]);
    const [companyLeads, setCompanyLeads] = React.useState([]);
    const [showUsers, setShowUsers] = React.useState(false);
    const [showLeads, setShowLeads] = React.useState(false);
    const [editInfo, setEditInfo] = React.useState(false);

    const fetchData = React.useCallback(async () => {
        try {
            setLoading(true);
            const fetchCompany = await getCompany(match.params.id);
            setCompany(fetchCompany);
            const companyServices = await getCompanyServices(match.params.id)
            setServices(companyServices);
            const compUsers = await getCompanyUsers(match.params.id);

            console.log(services)

            const companyLeads = await getAllCompanyLeads(match.params.id);
            setCompanyLeads(companyLeads);
            setCompanyUsers(compUsers)
            setLoading(false);
        } catch (e) {
            setError(true);
            setErrorText("Fel uppstod", e);
        }
    }, []);

    const handleSelectService = async (id) => {
        console.log(id)
    }

    useEffect(() => {
        fetchData().then(() => {
            setError(true);
            setErrorText(`Inladdning klar.`)
        }).finally(() => {
            setError(false)
        });


    }, [match.params.id]);


    const handleSubmitAmountOfAccounts = async () => {
        setLoading(true);
        if (amountRef === 0) {
            setError(true);
            setErrorText("Ändra värde på antal licenser.");
        } else {

            try {
                await updateAmountOfAccounts(amountRef, match.params.id).then(() => {
                    setError(true);
                    setErrorText(`Uppdaterade antal licenser till ${amountRef}`)
                }).finally(() => window.location.reload()
                )

            } catch {
                setError(true);
                setErrorText("Fel uppstod")
            }
        }

        setLoading(false);
    }

    const handleChangeAdminReference = async () => {
        setLoading(true);


        if (!referenceAdmin) {
            setError(true);
            setErrorText("Ändra Referensadmin.");
        }
        try {
            await updateCompanyReference(referenceAdmin, match.params.id).then(() => {
                window.location.reload();
            });

        } catch {

        }
        setLoading(false);
    }


    return (
        <>
            {error ? <Alert variant={"warning"}>{errorText}</Alert> : null}
            <Row>
                <Container fluid>
                    <h4>
                        {company.companyName} <Button onClick={() => setEditInfo(!editInfo)}> Redigera Information </Button>
                    </h4>
                </Container>

            </Row>

            <Row>
                <Col>

                    <Card>
                        <Form
                            style={{ padding: "30px", margin: " 30px" }}

                        >

                            <h6>Uppdatera mängden tillgängliga konton för {company.companyName}</h6>

                            <Form.Group id="email">
                                <Form.Label>Licenser: </Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) =>
                                        setAmountRef(e.target.value)}

                                />
                                <hr />
                                De har {company.amountofAccounts} tillgängliga just nu.

                            </Form.Group>

                            <Button disabled={loading} variant={"primary"}
                                onClick={() => handleSubmitAmountOfAccounts()}>
                                Spara
                            </Button>
                        </Form>
                    </Card>

                </Col>
                <Col>
                    <Card>
                        <Form
                            style={{ padding: "30px", margin: " 30px" }}
                        >
                            <h6>Uppdatera referensadmin för {company.companyName}</h6>
                            <Form.Group id="email">
                                <Form.Label>Referensadmin: </Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) =>
                                        setReferenceAdmin(e.target.value)}

                                />
                                <hr />
                                <b>{company.referensadmin}</b> är Referensadmin för tillfället.

                            </Form.Group>

                            <Button disabled={loading} variant={"primary"}
                                onClick={() => handleChangeAdminReference()}>
                                Spara
                            </Button>

                        </Form>
                    </Card>


                </Col>
                <Row>
                    <Col>
                        <Card>
                            <Card.Header>
                                {company.companyName}s tjänster:
                            </Card.Header>
                            <Card.Body>

                                <ul>
                                    {services.map(service => {
                                        return (
                                            <React.Fragment>
                                            <li key={service.QR}>
                                                Tjänst: {service.service} - Företag: {service.company} -
                                                QR: {service.QR}

                                               
                                            </li>
                                           
                                            </React.Fragment>
                                        )
                                    })}
                                </ul>

                                <AddServicesModal company={match.params.id} />
                            </Card.Body>
                        </Card>
                    </Col>
                    <Col>
                        <Card>
                            <Card.Header>
                                <Button variant={"primary"} onClick={() => setShowUsers(!showUsers)}>
                                    Visa {company.companyName}s användare</Button>
                            </Card.Header>
                            {showUsers ?
                                <Card.Body>

                                    <ul>
                                        {companyUsers.map(user => {
                                            return (
                                                <li key={user.uid}>
                                                    Namn: {user.displayName}
                                                    <br />
                                                    E-post {user.email}
                                                    <br />

                                                    Rättigheter: {formatAllowWebText(user.allowWeb)}
                                                    <hr />

                                                </li>
                                            )
                                        })}
                                    </ul>

                                </Card.Body> : null}
                        </Card>
                    </Col>
                    <Col>

                        <Card>
                            <Card.Header>
                                <Button variant={"primary"} onClick={() => setShowLeads(!showLeads)}>
                                    Visa {company.companyName}s leads</Button>
                            </Card.Header>
                            {showLeads ?
                                <Card.Body>

                                    <ul>
                                        {companyLeads.map(lead => {
                                            return (
                                                <li key={lead.uid}>
                                                    Referensadmin: {lead.reference}
                                                    <br />
                                                    Kund: {lead.email}
                                                    <br />
                                                    Kommun: {lead.district}
                                                    <br />
                                                    Dealstage: {formatText(lead.dealstage)}
                                                    <hr />
                                                </li>
                                            )
                                        })}
                                    </ul>

                                </Card.Body> : null}
                        </Card>
                    </Col>


                </Row>
            </Row>
        </>


    )
}
